export const paymentsConstant = {
  GET_ALL_REQUEST: 'PAYMENTS_GET_ALL_REQUEST',
  GET_ALL_SUCCESS: 'PAYMENTS_GET_ALL_SUCCESS',
  GET_ALL_FAILURE: 'PAYMENTS_GET_ALL_FAILURE',

  GET_REFUND_PAYMENT_REQUEST: 'PAYMENTS_GET_REFUND_PAYMENT_REQUEST',
  GET_REFUND_PAYMENT_SUCCESS: 'PAYMENTS_GET_REFUND_PAYMENT_SUCCESS',
  GET_REFUND_PAYMENT_FAILURE: 'PAYMENTS_GET_REFUND_PAYMENT_FAILURE',
}
